<template>
  <div class="static-quiz-list">
    <div class="panel">
      <van-cell-group
        v-for="sec in sections"
        :key="sec.title"
        inset
        :title="sec.title"
        class="semester-group"
      >
        <van-cell
          v-for="b in sec.banks"
          :key="b.id"
          :title="b.title"
          is-link
          @click="openBank(b)"
        />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { getBankSections } from "./staticQuizUtils";

export default {
  name: "StaticQuizList",
  data() {
    return {
      sections: getBankSections(),
    };
  },
  methods: {
    openBank(b) {
      this.$router.push({
        name: "StaticQuizPlay",
        query: { bank: encodeURIComponent(b.id) },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.static-quiz-list {
  min-height: 100vh;
  background: #f5f6f7;
  padding-bottom: 24px;
}

.panel {
  padding: 12px 0;
}

.semester-group + .semester-group {
  margin-top: 8px;
}
</style>
